var Vue = require('vue');
var axios = require('axios');
var VueAxios = require('vue-axios');
var sw = require('js/lib/sw');
var _ = require('underscore');
Vue.use(VueAxios, axios);



function arraysEqual(_arr1, _arr2) {

    if (!Array.isArray(_arr1) || ! Array.isArray(_arr2) || _arr1.length !== _arr2.length)
        return false;

    var arr1 = _arr1.concat().sort();
    var arr2 = _arr2.concat().sort();

    for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i])
            return false;

    }
    return true;

}


module.exports = function ($fragment) {
    $fragment.swFindWithSelf("[data-sw-manage-user-production-processes]").each(function () {
        new Vue({
            el: this,
            data: {
                workflows: sw.data.workflows,
                materials: sw.data.materials,
                userId: null,
                usersIdsInWorkflow: [],
                users: [],
                selectedProductionProcessId: null,
                selectedMaterialIds: [],
                showSaveButton: false,
                isLoading: false,
            },
            watch: {
                selectedProductionProcessId: function () {
                    this.getCurrentUsers(this.selectedProductionProcessId);
                },
                materials: {
                    handler: function(newValue) {
                        var initialSelectedMaterials = this.selectedMaterialIds;
                        var newSelectedMaterials = [];
                        newValue.forEach(function(material) {
                            if(material.isChecked) {
                                newSelectedMaterials.push(material.materialId)
                            }
                        });
                        if(arraysEqual(initialSelectedMaterials, newSelectedMaterials)) {
                            this.showSaveButton = false;
                        } else {
                            this.showSaveButton = true;
                        }
                    },
                    deep:true
                }
            },
            methods: {
                updateMaterials: function() {
                    var self = this;
                    var checkMaterialIds = self.materials.map(function (material) {
                        if (material.isChecked) {
                            return material.materialId
                        }
                    });
                    checkMaterialIds = checkMaterialIds.filter((i) => i);
                    var form = new FormData();
                    form.append('materialIds', checkMaterialIds);
                    form.append('productionProcessId', self.selectedProductionProcessId);

                    axios.post('/smt/manage-user-production-processes/update-materials', form)
                        .then(function (response) {
                            sw.notifications.success('Materials Updated!');
                        })
                        .catch(function (error) {
                            console.log(error);
                            if (error.response) {
                                sw.notifications.error(error.response.data.message)
                            } else {
                                sw.notifications.error("Something went wrong! Please try again.");
                            }
                        })

                },
                getCurrentUsers: function (productionProcessId) {
                    var self = this;
                    self.isLoading = true;
                    axios.get('/smt/manage-user-production-processes/get-users?productionProcessId=' + productionProcessId)
                        .then(function (response) {
                            if (response.data) {
                                var materialIds = response.data.materialIds;
                                self.usersIdsInWorkflow = response.data.userIds;
                                self.users = response.data.users;
                                self.selectedMaterialIds = materialIds;
                                self.materials.map(function (material) {
                                    material.isChecked = false;
                                    return material;
                                });
                                materialIds.forEach(function (materialId) {
                                    var materialObj = self.materials.find(function (material) {
                                        return material.materialId === materialId;
                                    });
                                    materialObj.isChecked = true;
                                })

                            }
                           self.isLoading = false;
                        })
                        .catch(function(error) {
                            console.log(error);
                        })
                },
                removeUser: function (userId) {
                    var self = this;
                    axios.get('/smt/manage-user-production-processes/remove-user?userId=' + userId)
                        .then(function (response) {
                            self.getCurrentUsers(self.selectedProductionProcessId);
                        })
                        .catch(function (error) {
                            console.log(error);
                        })
                },
                update: function () {
                    var self = this;
                    var checkMaterialIds = self.materials.map(function (material) {
                        if (material.isChecked) {
                            return material.materialId
                        }
                    });
                    checkMaterialIds = checkMaterialIds.filter((i) => i);
                    var form = new FormData();
                    form.append('userId', self.userId);
                    form.append('materialIds', checkMaterialIds);
                    form.append('productionProcessId', self.selectedProductionProcessId);

                    axios.post('/smt/manage-user-production-processes/update', form)
                        .then(function (response) {
                            sw.notifications.success('User Added!');
                            self.getCurrentUsers(self.selectedProductionProcessId);
                        })
                        .catch(function (error) {
                            console.log(error);
                            if (error.response) {
                                sw.notifications.error(error.response.data.message)
                            } else {
                                sw.notifications.error("Something went wrong! Please try again.");
                            }
                        })
                }
            }
        })
    });
};
